"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uxcore = require("@ux/uxcore2");
var _react = require("react");
var _chevronDown = _interopRequireDefault(require("@ux/icon/chevron-down"));
var _Button = require("./Button.styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class ScrollDownToContinueComponent extends _react.PureComponent {
  render() {
    const {
      action,
      dataEid,
      text
    } = this.props;
    return /*#__PURE__*/React.createElement(_Button.IconBelowTextButton, {
      className: "row text-center"
    }, /*#__PURE__*/React.createElement(_uxcore.Button, {
      "data-eid": dataEid,
      design: "inline",
      onClick: action,
      className: "scroll-down-container text-center",
      text: text,
      icon: /*#__PURE__*/React.createElement(_chevronDown.default, {
        width: 16,
        height: 16
      })
    }));
  }
}
ScrollDownToContinueComponent.propTypes = {
  action: _propTypes.default.func.isRequired,
  dataEid: _propTypes.default.string.isRequired,
  text: _propTypes.default.string.isRequired
};
var _default = exports.default = ScrollDownToContinueComponent;